define('koBsTooltip',['knockout', 'jquery'], function (ko, $) {
    "use strict";

    ko.bindingHandlers.bsTooltip = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            $(element).tooltip({title: ko.unwrap(valueAccessor()), html: !0 });
        },

        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            //element.setAttribute('data-ux-state', 'pending');
            //moduleLoader.loadPendingModules(element);
        }
    }
});
